<template>
  <button :disabled="disabled" @click="$emit('click')">
    {{ text }}
  </button>
</template>

<script>
export default {
  props: ["text", "disabled"],
};
</script>

<style scoped>
button {
  background-color: var(--quiz-button-color);
  color: var(--quiz-button-text-color);
  border: 0;
  border-radius: 0;
  padding: 15px 20px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.1px;
  cursor: pointer;
  transition: 0.15s linear all;
}

button:hover {
  background-color: var(--quiz-button-hover-color);
  color: var(--quiz-button-hover-text-color);
}

button:disabled {
  cursor: not-allowed;
}
</style>
